import { config } from '@/config';

const apiDomain = process.env.NEXT_PUBLIC_SITE_URL || '';
const websiteDomain = config.supertokens.hubUrl || '';
const apiBasePath = config.supertokens.apiBasePath || '';
const websiteBasePath = config.supertokens.websiteDomain || '';

export const appInfo = {
    // learn more about this on https://supertokens.com/docs/thirdpartyemailpassword/appinfo
    appName: 'Collinson Group Web App',
    apiDomain,
    websiteDomain,
    apiBasePath,
    websiteBasePath,
};
